export default __webpack_public_path__ + "static/media/bkg--team-1.80a1e4ca.jpg";